import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// rework this screen to match the funeral arrangements intro screen
import {
  ButtonBar, IntroScreenHeader, SectionDescription
} from '../../components';

const sections = [
  {
    title: 'Verify Personal Information',
    description: 'Confirm your name, date of birth, address, and contact details'
  },
  {
    title: 'Pregnancy Status',
    description: 'Provide information about your current pregnancy status'
  },
  {
    title: 'Physician Information',
    description: 'Provide details about your primary care physician and any specialists'
  },
  {
    title: 'Healthcare Agent Designation',
    description: 'Specify your healthcare agent or proxy decision-maker'
  },
  {
    title: 'Guardian/Conservator Preferences',
    description: 'Indicate your preferences for a guardian or conservator, if needed'
  },
  {
    title: 'Document Storage Preferences',
    description: 'Specify how you want your healthcare documents to be stored and accessed'
  },
  {
    title: 'Healthcare Wishes and Preferences',
    description: 'Outline your healthcare wishes and preferences, including end-of-life care'
  },
  {
    title: 'Organ Donation Preferences',
    description: 'Specify your preferences regarding organ donation'
  }
];

export function NewHDIntroScreen() {
  const navigate = useNavigate();
  
  const handleCancel = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('verify');
  }, [ navigate ]);
  
  return (
    <div className="new-fa-intro-screen screen-container">
      <IntroScreenHeader
        title="What we'll cover"
        description="This guided process will help you create your healthcare directive in just a few simple steps."
      />
      {sections.map((section, index) => (
        <SectionDescription key={index} title={section.title} description={section.description} />
      ))}
      <ButtonBar 
        handlePrimary={handleNext}
        handleSecondary={handleCancel}
        primaryText="Get Started"
        secondaryText="Cancel"
      />
    </div>
  );
}